<div class="comment-dialog">
  <div class="dialog-header">
    <button type="button" mat-icon-button (click)="closeDialog()" aria-label="Close">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2>Comment Log</h2>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-progress-bar *ngIf="loading || submitting" mode="indeterminate"></mat-progress-bar>

    <div class="form-section">
      <div class="section-header">
        <span class="section-icon primary">
          <mat-icon>forum</mat-icon>
        </span>
        <span>Comments</span>
      </div>

      <div *ngIf="loading" class="loading-wrap">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="loading-text">Loading comments...</p>
      </div>

      <div *ngIf="!loading && allCommentList.length" class="comment-list">
        <div
          *ngFor="let comment of allCommentList; let last = last"
          class="comment-item"
          [class.comment-item--last]="last">
          <div class="comment-avatar">
            <mat-icon>person</mat-icon>
          </div>

          <div class="comment-body">
            <div class="comment-meta">
              <span class="comment-author">{{ comment.user_name }}</span>
              <span class="comment-date">
                <mat-icon>schedule</mat-icon>
                {{ comment.created_at | date: 'MMM d, y, h:mm a' }}
              </span>
            </div>

            <p class="comment-text" *ngIf="comment.comment">{{ comment.comment }}</p>

            <div *ngIf="comment.comment_image" class="comment-image-wrap">
              <img
                [src]="storageUrl + '/' + comment.comment_image"
                alt="Comment image"
                class="comment-image"
                (click)="openImageDialog(storageUrl + '/' + comment.comment_image)" />
              <div class="image-overlay">
                <mat-icon>zoom_in</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && !allCommentList.length" class="empty-state">
        <mat-icon>chat_bubble_outline</mat-icon>
        <h5>No comments yet</h5>
        <p>Be the first to add a comment.</p>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="compose-section">
    <div class="compose-form">
      <div class="form-group form-group--full">
        <label for="new-comment">Write a comment</label>
        <div class="form-field">
          <textarea
            id="new-comment"
            class="w-100"
            [(ngModel)]="newComment"
            rows="3"
            placeholder="Share your thoughts...">
          </textarea>
        </div>
      </div>

      <div *ngIf="issuePhotoPreview" class="attachment-preview">
        <div class="attachment-info">
          <mat-icon>check_circle</mat-icon>
          <span>Image attached</span>
        </div>
        <div class="attachment-actions">
          <img
            [src]="issuePhotoPreview"
            alt="Preview"
            class="preview-thumb"
            (click)="openImageDialog(issuePhotoPreview!)" />
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="deleteFile()"
            matTooltip="Remove image">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div class="compose-actions">
        <div class="compose-left">
          <button
            type="button"
            class="attach-button"
            mat-stroked-button
            (click)="fileInput.click()">
            <mat-icon>attach_file</mat-icon>
            {{ issuePhotoPreview ? 'Change Image' : 'Attach Image' }}
          </button>
          <input
            #fileInput
            type="file"
            class="file-input"
            accept="image/*"
            (change)="onFileSelect($event)" />

          <mat-checkbox [(ngModel)]="notifyCustomer" class="notify-checkbox">
            Notify Customer
          </mat-checkbox>
        </div>

        <button
          type="button"
          class="submit-button"
          mat-flat-button
          color="primary"
          (click)="onAddComment()"
          [disabled]="submitting || (!newComment.trim() && !issuePhotoPreview)">
          <mat-icon>send</mat-icon>
          <span *ngIf="!submitting">Post Comment</span>
          <span *ngIf="submitting">Posting...</span>
        </button>
      </div>
    </div>
  </div>
</div>
